import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { cookieData } from '../funciones/ConsultaUser';
import { consultaUser } from './PefilFunction';

export const ConsultInscripcion = (respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario
        }

        Post(`${Url}consultInscripcion`, Content, (resp) => {
            let data = JSON.parse(resp);

            let notificacionClass = "custom-alert-info";
            let notificacionIcon = "fa fa-circle-o-notch fa-spin";
            let notificacionText = "Verificando, espera por favor";
            let carrera = "";
            let btn = 1;
            switch (data.status) {
                case "InsP":
                    notificacionClass = "custom-alert-warning";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "Inscripción pendiente por aprobación";
                    carrera = "";
                    btn = 2;
                    break;
                case "nIns":
                    notificacionClass = "custom-alert-warning";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "No estas inscrito";
                    carrera = "";
                    btn = 1;
                    break;
                case "Ins":
                    notificacionClass = "custom-alert-success";
                    notificacionIcon = "fa fa-check";
                    notificacionText = `Estas inscrito actualmenete en ${data.carrera.carrera_name}`;
                    carrera = data.carrera.carrera_name;
                    btn = 0;
                    break;
                default:
                    notificacionClass = "custom-alert-warning";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "No estas inscrito";
                    carrera = "";
                    btn = 1
                    break;
            }

            let state = {
                icon: notificacionIcon,
                text: notificacionText,
                class: notificacionClass,
                styles:{fontSize:12, position:"absolute", top: 4}
            }

            let datosEst = {
                datosPersonales: data.datosPersonales,
                carrera: carrera,
                materias: data.materias,
            }

            respuesta([state, data.solicitudes, datosEst, btn, data.solicAbiertas])
        });
    })
}

export const ConsultaSolicitud = (tipo, respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            tipoC: tipo,
            id: usuario
        }

        Post(`${Url}consultSolicitud`, Content, (resp) => {
            let data = JSON.parse(resp);

            let notificacionClass = "custom-alert-info";
            let notificacionIcon = "fa fa-circle-o-notch fa-spin";
            let notificacionText = "Verificando, espera por favor";
            let carrera = "";
            let btn = 1;
            switch (data.status) {
                case "InsP":
                    notificacionClass = "custom-alert-warning";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "Inscripción pendiente por aprobación";
                    carrera = "";
                    btn = 2;
                    break;
                case "nIns":
                    notificacionClass = "custom-alert-warning";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "No estas inscrito";
                    carrera = "";
                    btn = 1;
                    break;
                case "Ins":
                    notificacionClass = "custom-alert-success";
                    notificacionIcon = "fa fa-check";
                    notificacionText = `Estas inscrito actualmenete en ${data.carrera.carrera_name}`;
                    carrera = data.carrera.carrera_name;
                    btn = 0;
                    break;
                default:
                    notificacionClass = "custom-alert-warning";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "No estas inscrito";
                    carrera = "";
                    btn = 1
                    break;
            }

            let state = {
                icon: notificacionIcon,
                text: notificacionText,
                class: notificacionClass,
                styles:{fontSize:12, position:"absolute", top: 4}
            }

            let datosEst = {
                datosPersonales: data.datosPersonales,
                carrera: carrera,
                materias: data.materias,
            }

            respuesta([state, data.solicitudes, datosEst, btn, data.solicAbiertas])
        });
    })
}

export const ConsultInscripcionInd = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}consultInscripcionInd`, Content, (resp) => {
            let data = JSON.parse(resp);

            let notificacionClass = "custom-alert-info";
            let notificacionIcon = "fa fa-circle-o-notch fa-spin";
            let notificacionText = "Verificando, espera por favor";
            let carrera = "";
            let btn = 1;
            switch (data.status) {
                case "InsP":
                    notificacionClass = "custom-alert-warning";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "Inscripción pendiente por aprobación";
                    carrera = "";
                    btn = 2;
                    break;
                case "nIns":
                    notificacionClass = "custom-alert-warning";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "El estudiante no está inscrito";
                    carrera = "";
                    btn = 1;
                    break;
                case "Ins":
                    notificacionClass = "custom-alert-success";
                    notificacionIcon = "fa fa-check";
                    notificacionText = `El estudiante está inscrito actualmenete en ${data.carrera.carrera_name}`;
                    carrera = data.carrera.carrera_name;
                    btn = 0;
                    break;
                default:
                    notificacionClass = "custom-alert-warning";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "El estudiante no está inscrito";
                    carrera = "";
                    btn = 1
                    break;
            }

            let state = {
                icon: notificacionIcon,
                text: notificacionText,
                class: notificacionClass,
                styles:{fontSize:12, position:"absolute", top: 4}
            }

            let datosPer = "";
            let datosSolicitud = "";
            if ((data.datosPersonales) !== undefined) datosPer = data.datosPersonales;
            if ((data.solicitudes) !== undefined) datosSolicitud = data.solicitudes;

            let datosEst = {
                datosPersonales: datosPer,
                carrera: carrera,
                materias: data.materias,
                director: data.director,
                ctrEstudios: data.ctrEstudios
            }

            respuesta([state, datosSolicitud, datosEst, btn])
        });
    });
}

export const consultaSolicitudInd = (id, tipo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id,
            tipo: tipo
        }

        Post(`${Url}consultaSolicitudInd`, Content, (resp) => {
            let data = JSON.parse(resp);

            let notificacionClass = "custom-alert-info";
            let notificacionIcon = "fa fa-circle-o-notch fa-spin";
            let notificacionText = "Verificando, espera por favor";
            let carrera = "";
            let btn = 1;
            switch (data.status) {
                case "InsP":
                    notificacionClass = "custom-alert-warning";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "Inscripción pendiente por aprobación";
                    carrera = "";
                    btn = 2;
                    break;
                case "nIns":
                    notificacionClass = "custom-alert-warning";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "El estudiante no está inscrito";
                    carrera = "";
                    btn = 1;
                    break;
                case "Ins":
                    notificacionClass = "custom-alert-success";
                    notificacionIcon = "fa fa-check";
                    notificacionText = `El estudiante está inscrito actualmenete en ${data.carrera.carrera_name}`;
                    carrera = data.carrera.carrera_name;
                    btn = 0;
                    break;
                default:
                    notificacionClass = "custom-alert-warning";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "El estudiante no está inscrito";
                    carrera = "";
                    btn = 1
                    break;
            }

            let state = {
                icon: notificacionIcon,
                text: notificacionText,
                class: notificacionClass,
                styles:{fontSize:12, position:"absolute", top: 4}
            }

            let datosPer = "";
            let datosSolicitud = "";
            if ((data.datosPersonales) !== undefined) datosPer = data.datosPersonales;
            if ((data.solicitudes) !== undefined) datosSolicitud = data.solicitudes;

            let datosEst = {
                datosPersonales: datosPer,
                carrera: carrera,
                materias: data.materias,
                cedulaDir: data.ci_director,
                nameDir: data.name_director,
                lapsoIn: data.lapso_in,
                lapsoOut: data.lapso_out,
                aCursados: data.a_cursados,
                horasAp: data.horas_ap,
                horasApL: data.horas_ap_letra,
                ucAp: data.uc_ap,
                ucApL: data.uc_ap_letra 
            } 

            respuesta([state, datosSolicitud, datosEst, btn])
        });
    });
}

export const GenerarSolicitud = (tipoC, respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario,
            tipoC: tipoC
        }
        
        Post(`${Url}SolicitudDoc`, Content, (resp) => {
            respuesta(resp)
        });
    })
}

export const GenerarConstancia = (respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario
        }
        
    Post(`${Url}generarConstanciaEst`, Content, (resp) => {
            respuesta(resp)
        });
    })
}

export const GenerarConstanciaInd = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}generarConstanciaEstInd`, Content, (resp) => {
            respuesta(resp)
        });
    })
}

export const GenerarSolicitudInd = (id, tipo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id,
            tipo: tipo
        }

        Post(`${Url}generarSolicitudEstInd`, Content, (resp) => {
            respuesta(resp)
        });
    })
}

export const ConstanciasPendientes = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}constPendientes`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const SolicitudesPendientes = (tipo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            tipo: tipo
        }

        Post(`${Url}solicitudesPendientes`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const ConsultCarrera = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}consultCarreraEst`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const NoAceptar = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}NoApConstancia`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const NoAceptarSol = (id, tipo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id,
            tipo: tipo
        }

        Post(`${Url}NoAceptarSol`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const AceptarConst = (id, check, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id,
            check: check
        }

        Post(`${Url}ApConstancia`, Content, (resp) => {
            let data = JSON.parse(resp)

            let datosPer = "";
            if ((data.datosPersonales) !== undefined) datosPer = data.datosPersonales;

            let datosEst = {
                datosPersonales: datosPer,
                carrera: data.carrera.carrera_name,
                materias: data.materias,
                ctrEstudios: data.ctrEstudios,
                director: data.director
            }

            respuesta([data, datosEst])
        });
    });
}

export const AceptarSol = (id, check, tipo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id,
            check: check,
            tipo: tipo
        }
        Post(`${Url}AceptarSol`, Content, (resp) => {
            let data = JSON.parse(resp)


            let datosPer = "";
            if ((data.datosPersonales) !== undefined) datosPer = data.datosPersonales;

            let datosEst = {
                datosPersonales: datosPer,
                carrera: data.carrera.carrera_name,
                cedulaDir: data.ci_director,
                nameDir: data.name_director,
                lapsoIn: data.lapso_in,
                lapsoOut: data.lapso_out,
                aCursados: data.a_cursados,
                horasAp: data.horas_ap,
                horasApL: data.horas_ap_letra,
                ucAp: data.uc_ap,
                ucApL: data.uc_ap_letra            }

            respuesta([data, datosEst])
        });
    });
}

export const ConsultHistorico = (respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario
        }
        
        Post(`${Url}consultHistConstancia`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    })
}

export const ConsultHistoricoSol = (tipoC, respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario,
            tipoC: tipoC
        }
        
        Post(`${Url}ConsultHistoricoSol`, Content, (resp) => {
            respuesta(resp)
        });
    })
}


// WEBPACK FOOTER //
// ./src/funciones/ConstanciaFunction.jsx